<template>
  <div>
    <AddQuestions :key="$route.query.status" />
  </div>
</template>
<script>
import AddQuestions from '../../../components/skillup/courses/AddQuestions.vue'
export default {
  name: 'skillUp-question-courses',
  components: { AddQuestions },
}
</script>
